var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "640.000000pt",
    height: "564.000000pt",
    viewBox: "0 0 640.000000 564.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,564.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3105 5626 c-65 -21 -117 -52 -157 -93 -34 -35 -2872 -4935 -2921 -5043 -15 -34 -21 -67 -21 -135 -1 -78 3 -98 26 -147 34 -73 103 -142 176 -176 l57 -27 2935 0 2935 0 57 27 c73 34 142 103 176 176 23 48 27 71 27 142 0 47 -6 101 -13 121 -7 20 -657 1154 -1446 2520 -1598 2772 -1484 2586 -1620 2628 -76 23 -151 26 -211 7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dc2626",
    d: "M3105 5491 c-22 -10 -52 -31 -67 -47 -27 -29 -2841 -4897 -2884 -4989 -57 -121 -5 -261 115 -311 49 -21 5815 -21 5864 -1 108 46 165 175 125 288 -18 51 -2865 4979 -2896 5013 -39 42 -98 66 -162 66 -32 0 -71 -8 -95 -19z m1187 -2864 l1086 -1882 -1089 -3 c-599 -1 -1579 -1 -2178 0 l-1088 3 1086 1882 c597 1036 1088 1883 1091 1883 3 0 494 -847 1092 -1883z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3085 3826 c-93 -29 -165 -101 -184 -185 -13 -60 153 -1925 175 -1958 47 -73 216 -73 255 0 8 13 46 406 95 967 66 748 81 954 73 990 -27 122 -146 201 -302 199 -40 0 -90 -6 -112 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3120 1501 c-94 -31 -177 -107 -204 -188 -50 -147 10 -303 145 -378 48 -27 63 -30 139 -30 73 0 92 4 136 27 64 34 128 105 148 165 9 26 16 74 16 108 0 168 -119 294 -285 301 -38 2 -81 0 -95 -5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.116265c6dfaeb7df20dd4bf42a4b01a1.svg";
export { ForwardRef as ReactComponent };